import Vue from 'vue'
import API from '../utils/api'
import env from '../../../config/prod.env.js'

const state = {
  scalevalues: [],
  scalevalue: null,
  sortAd: [],
  currentPage: null
}

const mutations = {  
  SET_SCALEVALUES (state, payload) {
    state.scalevalues = payload
  },
  SET_CURRENT_PAGE (state, payload) {
    state.currentPage = payload
  },
  SET_SCALEVALUE (state, payload) {
    state.scalevalue = payload
  },
  SET_SORT_AD (state, payload) {
    state.sortAd = payload
  },
  SET_CURRENT_PAGE (state, payload) {
    state.currentPage = payload
  },
  API_FAILURE (state, payload) {
    throw {error: true, payload: payload.body}
  } 
}

const actions = {
  scaleValuesList: (context, id) => {
    return Vue.http.get(`${env.API}/api/scale-values`)    
      .then((response) => {        
        context.commit('SET_SCALEVALUES', response.body)
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  paginatedList: (context, data) => {
    let query = '?'        
    if (data.pagination) {
      query += `page=${data.pagination.page}&records=${data.pagination.perPage}`      
    } else {          
      query = ''
    }
    if (data.sort) {
      query += `&sortBy=${data.sort.sortBy}&sortDesc=${data.sort.sortDesc}`      
    }
    if (data.search) {
      query += `&search=${data.search}`      
    }

    return Vue.http.post(`${env.API}/api/scale-values/paginated-list`, data)    
      .then((response) => {        
        context.commit('SET_SCALEVALUES', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  updateCurrentPage: (context, page) => {
    return context.commit('SET_CURRENT_PAGE', page)
  },
  deleteScaleValue: (context, data) => {
    return Vue.http.delete(`${env.API}/api/scale-values/${data.id}`, data)
    .then((response) => {
      return response.body.message
    })
    .catch((error) => {
      return context.commit('API_FAILURE', error)
    })
  },
  getScaleValueById: (context, id) => {
    return Vue.http.get(`${env.API}/api/scale-values/by-id/${id}`)    
      .then((response) => {
        context.commit('SET_SCALEVALUE', response.body.message)            
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  updateScaleValue: (context, data) => {
    return Vue.http.put(`${env.API}/api/scale-values/${data.id}`, data)    
      .then((response) => {                
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  createScaleValue: (context, data) => {
    return Vue.http.post(`${env.API}/api/scale-values`, data)    
      .then((response) => {                
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  updateSortAd: (context, data) => {
    return context.commit('SET_SORT_AD', data)
  },
  getLastMinutesByUserEvaluated: (context, data) => {
    let query = '?'        
    if (data.pagination) {
      query += `page=${data.pagination.page}&records=${data.pagination.perPage}`      
    } else {          
      query = ''
    }

    return Vue.http.get(`${env.API}/api/session/last-minutes-by-userevaluated/${data.id}/${data.sessionid}${query}`)
      .then((response) => {
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  }
}

const getters = {
  getScaleValues: (state) => state.scalevalues,
  getScaleValue: (state) => state.scalevalue,
  getSortAd: (state) => state.sortAd,
  getCurrentPage: (state) => state.currentPage
}

export const scalevalues = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/scale_value.js